const Constantes = {
    NOMBRECKUSUARIO: 'IFUSUARIO',
    NOMBRECKCOOKIE: 'IFCOOKIEUSUARIO',
    TIPO_ENTIDAD_PROVEEDOR:'P',
    tituloSitio: "Retención",
    sitename: "qrfacil.link",
    estadosPublicado: ["Publicado", "No Publicado"],
    estadoActivo: "ACT",
    estadoInactivo: "INA",
    estRegistro: [
        {label: 'Activo', value: 'ACT'},
        {label: 'Inactivo', value: 'INA'}
    ],
    estEstudiante: [
        {label: 'Registrado', value: 1},
        {label: 'Pagado', value: 2},
        {label: 'Inactivo', value: 3},
    ],
    tipoDatoPerfil:[
        {label: 'Texto', value:'t'},
        {label: 'Correo', value:'c'},
        {label: 'Whatsapp', value:'w'},
        {label: 'Teléfono', value:'p'},
        {label: 'Url', value:'u'},
        {label: 'Fecha', value:'f'},
    ],
    estadoPago: ['PAGADA','PENDIENTE','ABONADA','DEVUELTA']
}

export default Constantes;